import React from 'react'

import { GP_DEFAULT } from 'constants/globalPreloaderStatuses.js'

import GlobalPreloader from 'components/_old/GlobalPreloader/GlobalPreloader.jsx'

const Loading = () => <GlobalPreloader status={GP_DEFAULT} loading />

export { Loading }
